import { Button, FlexRow, Hr, Stack, Text } from "atoms";
import { ProductWizardStep } from "../ProductWizardStep";
import { ProductDetails } from "../ProductDetails";
import type { StepProps } from "../../types";

function StepConfirmation({ dispatch, state, moveBack }: StepProps) {
  return (
    <ProductWizardStep
      stepTitle="Preview Product Listing"
      state={state}
      moveBack={moveBack}
    >
      <Stack gap="sm">
        <ProductDetails
          artistId={state.artistId}
          handle={state.product.handle}
          isPreview
        />

        <Hr />

        <FlexRow justifyContent="flex-end" gap="1.5rem">
          {/* TODO: Create different actions for SAVE DRAFT vs PUBLISH */}
          <Text
            size="sm"
            bold
            style={{ margin: "2px 0 0 0", opacity: 0.85 }}
            as="em"
          >
            Product Saved as a Draft
          </Text>
          <Button onClick={() => dispatch({ type: "moveNext" })}>
            Publish Now
          </Button>
        </FlexRow>
      </Stack>
    </ProductWizardStep>
  );
}

StepConfirmation.displayName = "Preview";

export { StepConfirmation };
